import { UserSubscriptionService } from "./user-subscription.service";
import type { IUserSubscriptionService } from "./user-subscription.service.interface";

export const userSubscriptionService: IUserSubscriptionService = new UserSubscriptionService();
